export default "__VITE_ASSET__Hrm9cL3c__"